Vue.component('settings', {
  template: templates.settings,
  data() {
    return {
      model: {
        settings: {},
        hasResult: false
      },
      cancelTokenSource: null
    }
  },
  mounted() {
    const c = this;
    c.get();
  },
  beforeDestroy() {
    const c = this;
    if (c.cancelTokenSource) {
      c.cancelTokenSource.cancel('Request canceled due to component destruction.');
    }
  },
  methods: {
    get() {
      const c = this;
      let data = {};

      c.cancelTokenSource = axios.CancelToken.source();

      settingsService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.settings = data;
          c.model.hasResult = true
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    save(id) {
      const c = this;
      const data = c.model.settings[`${id}`];

      settingsService.save(data)
        .then(function (response) {
          utils.alert.error('Setting Saved');
        })
        .catch(function (error) {
          //console.log(error);
        });
    }
  }
});